import fileConfig from './firebase.config.json';

const env = process.env;

export const firebaseConfig = {
  apiKey: env.REACT_APP_FIREBASE_API_KEY || fileConfig.apiKey,
  authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN || fileConfig.authDomain,
  projectId: env.REACT_APP_FIREBASE_PROJECT_ID || fileConfig.projectId,
  storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET || fileConfig.storageBucket,
  messagingSenderId:
    env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || fileConfig.messagingSenderId,
  appId: env.REACT_APP_FIREBASE_APP_ID || fileConfig.appId,
  measurementId: env.REACT_APP_FIREBASE_MEASUREMENT_ID || fileConfig.measurementId,
};

export const VAPID_KEY =
  env.REACT_APP_FIREBASE_VAPID_KEY || fileConfig.vapidKey;

export const FIREBASE_CDN_VERSION = fileConfig.firebaseCdnVersion || '12.11.0';

export const getFirebaseConfigSummary = () => ({
  projectId: firebaseConfig.projectId,
  appId: firebaseConfig.appId,
  messagingSenderId: firebaseConfig.messagingSenderId,
  apiKeyPrefix: `${firebaseConfig.apiKey?.slice(0, 8)}...`,
  vapidKeyPrefix: `${VAPID_KEY.slice(0, 8)}...`,
});
